import { createStyles } from "@mantine/emotion";

export const useStylesHelpVideo = createStyles((theme) => ({
  helpVideo: {
    position: "absolute",
    right: 0,
    top: theme.spacing.helpVideo.top,
    marginRight: theme.spacing.helpVideo.marginRight,
    border: `1px solid ${theme.customBackgrounds.greenLight}`,
    padding: theme.spacing.helpVideo.padding,
    textAlign: "left",
    width: theme.spacing.helpVideo.width,
    height: theme.spacing.helpVideo.height,
    transition:
      "width 0.5s ease, height 0.5s ease, padding 0.5s ease, background-color 0.5s ease",

    [`@media (max-width: ${theme.breakpoints.tabletCustomSmallMax})`]: {
      top: theme.spacing.helpVideo.topTabletSmall,
      marginRight: theme.spacing.helpVideo.marginRightTabletSmall,
    },

    [`@media (max-width: ${theme.breakpoints.mobileMaxVideo})`]: {
      display: "none",
    },

    ".help__video-icon": {
      cursor: "pointer",
      opacity: 0.6,
      width: theme.spacing.helpVideo.iconSize,
      height: theme.spacing.helpVideo.iconSize,
      transition: "width 0.5s ease, height 0.5s ease",
    },

    ".help__video-close": {
      opacity: 0,
      position: "absolute",
      zIndex: -1,
      right: theme.spacing.helpVideo.closeRight,
      top: theme.spacing.helpVideo.closeTop,
      cursor: "pointer",
      transition: "z-index 0.5s ease, opacity 0.5s ease",
    },

    ".help__video-text": {
      opacity: 0,
      whiteSpace: "nowrap",
      paddingTop: theme.spacing.helpVideo.textPaddingTop,
      overflow: "hidden",
      width: "0%",
    },

    ".help__video-link": {
      opacity: 0,
      whiteSpace: "nowrap",
      width: "0%",
      display: "block",
      overflow: "hidden",
    },

    "&.active": {
      backgroundColor: theme.customBackgrounds.tooltip,
      width: theme.spacing.helpVideo.activeWidth,
      height: theme.spacing.helpVideo.activeHeight,
      padding: theme.spacing.helpVideo.activePadding,

      [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
        width: theme.spacing.helpVideo.activeWidthTablet,
      },

      "&::before": {
        content: '""',
        position: "absolute",
        top: "40%",
        left: theme.spacing.helpVideo.beforeLeft,
        width: 0,
        height: 0,
        borderLeft: "0.467em solid transparent",
        borderRight: "0.467em solid transparent",
        borderBottom: "0.733em solid #C6E870",
        transform: "rotate(-90deg)",
      },

      "&::after": {
        content: '""',
        position: "absolute",
        top: "40%",
        left: theme.spacing.helpVideo.afterLeft,
        width: 0,
        height: 0,
        borderLeft: "0.467em solid transparent",
        borderRight: "0.467em solid transparent",
        borderBottom: "0.733em solid #EDF0E5",
        transform: "rotate(-90deg)",
      },

      ".help__video-icon": {
        width: theme.spacing.helpVideo.iconSizeActive,
        height: theme.spacing.helpVideo.iconSizeActive,
        cursor: "default",
        opacity: 1,
      },

      ".help__video-close": {
        opacity: 1,
        zIndex: 0,
      },

      ".help__video-text": {
        opacity: 1,
        width: "100%",
        color: theme.customColors.black,
        fontSize: theme.spacing.helpVideo.textFontSize,
        lineHeight: theme.spacing.helpVideo.textLineHeight,
        fontFamily: theme.headings.fontFamily.light,
      },

      ".help__video-link": {
        opacity: 1,
        width: "100%",
        fontSize: theme.spacing.helpVideo.textFontSize,
        lineHeight: theme.spacing.helpVideo.textLineHeight,
        fontFamily: theme.headings.fontFamily.light,
        color: "#000",
        a: {
          textDecoration: "underline",
          paddingRight: "0",
          paddingLeft: "0.333em",

          "&:hover": {
            textDecoration: "none",
          },
        },
      },
    },
  },
}));
